import { render, staticRenderFns } from "./setHierarchy.vue?vue&type=template&id=3ea74335&scoped=true"
import script from "./setHierarchy.vue?vue&type=script&lang=js"
export * from "./setHierarchy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea74335",
  null
  
)

export default component.exports